export enum TIER_NAME {
  IDENTITY = 'IDENTITY',
  ADDRESS_DOCUMENT = 'ADDRESS_DOCUMENT',
  ACCREDITATION = 'ACCREDITATION',
}
